import { Box, Typography } from "@mui/material";
import CustomTooltip from "../../../../components/CustomTooltip";
import CustomLabel from "../../frameworks/components/CustomLabel";

export const NISTCategoryIdentifier = ({
  nistFunction,
  nistIdentifiers,
  size = "small",
}) => {
  let identifiersList = [];

  if (nistIdentifiers && nistIdentifiers.length > 0) {
    identifiersList = Array.from(nistIdentifiers);
  }

  if (identifiersList.length === 0) {
    return null;
  }

  const primaryIdentifier = identifiersList[0];
  const additionalIdentifiersCount = identifiersList.length - 1;
  const additionalIdentifiers = identifiersList.slice(1);

  // Create tooltip content with additional identifiers as CustomLabels
  const tooltipContent = (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 0.5, paddingY: 0.5 }}
    >
      {additionalIdentifiers.map((identifier, index) => (
        <CustomLabel
          key={index}
          text={identifier}
          colorFamily="NIST"
          severity={nistFunction}
          labelType="outlined"
          size={size}
        />
      ))}
    </Box>
  );

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <CustomLabel
        text={primaryIdentifier}
        colorFamily="NIST"
        severity={nistFunction}
        labelType="outlined"
        size={size}
      />
      {additionalIdentifiersCount > 0 && (
        <CustomTooltip title={tooltipContent} placement="right">
          <Typography variant="caption">
            +{additionalIdentifiersCount}
          </Typography>
        </CustomTooltip>
      )}
    </Box>
  );
};

export default NISTCategoryIdentifier;
